import List from '../components/list.js';
import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Professions = () => {
    const [professions, setProfessions] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const setContext = useContext(Context)[1];
    const [checks, setChecks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [professionText, setProfessionText] = useState('');
    const [updateId, setUpdateId] = useState(-1);
    setContext('Professions');
    const headings = [
        { key: 'id', name: 'ID' },
        { key: 'text', name: 'Profession' }
    ]
    const loadProfessions = (page) => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'profession', {
            page: page,
            search: search
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setTotalRecords(r.data.total);
                setProfessions(r.data.results);
            }
        });
    }
    const addProfession = () => {
        axios.post(process.env.REACT_APP_API_URL + 'profession/add', {
            text: professionText
        }).then(r => {
            setLoading(false);
            setProfessionText('');
            setUpdateId(-1);
            if (r?.data?.status === 'Success') {
                loadProfessions(currentPage);
                setChecks(Array.apply(null, Array(professions?.length)).map(() => false));
            }
        });
    }
    const updateProfession = () => {
        axios.post(process.env.REACT_APP_API_URL + 'profession/update', {
            id: updateId,
            text: professionText
        }).then(r => {
            setLoading(false);
            setProfessionText('');
            setUpdateId(-1);
            if (r?.data?.status === 'Success') {
                loadProfessions(currentPage);
                setChecks(Array.apply(null, Array(professions?.length)).map(() => false));
            }
        });
    }
    const deleteProfessions = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(professions[i].id);
            }
            return acc
        }, []);
        if (ids.length === 0)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'profession/delete', {
            ids: ids
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                loadProfessions(currentPage);
                setChecks(Array.apply(null, Array(professions?.length)).map(() => false));
            }
        });
    }
    useEffect(() => {
        loadProfessions(0);
    }, []);
    useEffect(() => {
        setChecks(Array.apply(null, Array(professions?.length)).map(() => false));
    }, [professions]);
    const pageSize = 20;
    var pages = [];
    for (var i = Math.max(0, currentPage - 3); i < Math.min(currentPage + 4, Math.ceil(totalRecords / pageSize)); i++) {
        pages.push(i);
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form mb-10">
                    <label htmlFor="profession-text" style={{marginBottom: -5}}>{updateId == -1 ? "Add New Profession" : "Update Profession"}</label>
                    <div className="w-100 f-row gap-10 mb-15">
                        <input id="profession-text" type="text" className="w-100" value={professionText} onChange={e => setProfessionText(e.target.value)} />
                        {updateId == -1 ? (
                            <button className="btn" onClick={addProfession}>Add</button>
                        ) : (
                            <>
                                <button className="btn" onClick={updateProfession}>Update</button>
                                <button className="btn btn-red" onClick={() => {
                                    setProfessionText('');
                                    setUpdateId('');
                                }}>Cancel</button>
                            </>
                        )}
                    </div>
                    <div className="mw-300 w-100 gap-15 f-row">
                        <button className="link-styles" onClick={deleteProfessions}>Delete</button>
                    </div>
                    <div className="mw-300 w-100 ml-auto gap-10 f-row f-end">
                        <input type="search" placeholder="Search Professions" value={search} onChange={(e) => setSearch(e.target.value)} />
                        <button className="btn" onClick={() => { setCurrentPage(0); loadProfessions(0)}}> Search</button>
                    </div>
                </div>
                <List list={professions} actions={[{
                    text: (e) => {
                        return 'Update'
                    },
                    action: (e) => {
                        setProfessionText(e.text);
                        setUpdateId(e.id);
                    }
                },{
                    text: (e) => {
                        return 'Delete'
                    },
                    action: (e) => {
                        setLoading(true);
                        axios.post(process.env.REACT_APP_API_URL + 'profession/delete', {
                            ids: [e.id]
                        }).then(r => {
                            setLoading(false);
                            if (r?.data?.status === 'Success') {
                                loadProfessions(currentPage);
                                setChecks(Array.apply(null, Array(professions?.length)).map(() => false));
                            }
                        });
                    }
                }]} href="event" headings={headings} loading={loading} onCheck={setChecks} />
                <div className="list-arrows">
                    {currentPage > 0 && (
                        <button className="btn btn-square btn-arrow" onClick={() => {
                            loadProfessions(currentPage - 1);
                            setCurrentPage(c => c - 1);
                        }}>{'\u2039'}</button>
                    )}
                    {pages.map(p => (
                        <button key={p} className={"btn btn-squared" + (p == currentPage ? ' current-page' : '')} onClick={() => {
                            loadProfessions(p);
                            setCurrentPage(p);
                        }}>{p + 1}</button>
                    ))}
                    {(currentPage + 1) * pageSize < totalRecords - 1 && (
                        <button className="btn btn-square btn-arrow" onClick={() => {
                            loadProfessions(currentPage + 1);
                            setCurrentPage(c => c + 1);
                        }}>{'\u203A'}</button>
                    )}
                </div>
            </div>
        </main>
    )
}

export default Professions;